export const LEARN_MORE_LINK = 'https://controltheroom.com/control-room';
export const ADMIN_URL = 'https://app.controltheroom.com/admin';
export const PRIVACY_POLICY_LINK = 'https://controltheroom.com/privacy-policy';
